/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteShiftSchedules} from '../api'

export const useMutationDeleteShiftSchedules = createReactQueryMutationHook('deleteShiftSchedules', deleteShiftSchedules)
